import AppProviders from '@/components/AppProviders'
import { useAssetsFonts } from '@/hooks/useAssetsFonts'
import Constants from 'expo-constants'
import { Slot } from 'expo-router'
import { FC } from 'react'

export { RootLayoutErrorBoundary as ErrorBoundary } from '@/error-boundaries'

const Layout: FC = () => {
    useAssetsFonts()

    return (
        <AppProviders>
            <Slot />
        </AppProviders>
    )
}

let AppEntry = Layout

if (Constants.expoConfig?.extra?.storybookEnabled) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    AppEntry = require('@/storybook/index').default
}

export default AppEntry
